import React from 'react';
import { Star } from 'lucide-react';
import { motion } from 'framer-motion';
const testimonials = [{
  quote: 'Tengo 42 años, dos hijos y un trabajo demandante. Pensé que el triatlón no era para mí. Con este plan completé mi primer Sprint en La Plata en 4 meses. Increíble.',
  name: 'Martín Sosa',
  role: 'Buenos Aires'
}, {
  quote: 'Las sesiones son cortas pero exigentes. Antes entrenaba 10 horas sin un plan claro y no avanzaba. Ahora con 6 bien organizadas mejoré mis tiempos en running.',
  name: 'Laura Giménez',
  role: 'Rosario'
}, {
  quote: 'Lo mejor: la flexibilidad. Si un día no puedo entrenar, sé cómo recuperar la semana sin estresarme. Las calculadoras de hidratación me salvaron en verano.',
  name: 'Diego Martínez',
  role: 'Córdoba'
}, {
  quote: 'Soy médico, 38 años, y siempre puse excusas. Este sistema me sacó las dudas. Lo de los suplementos validados me ahorró plata y errores. Lo recomiendo.',
  name: 'Federico Álvarez',
  role: 'Mendoza'
}, {
  quote: 'A los 35 me animé al triatlón gracias a este plan. Es claro, directo y sin vueltas. Hice mi primera distancia Short y ya estoy preparándome para la Olímpica.',
  name: 'Carolina Pérez',
  role: 'Mar del Plata'
}];
export function Testimonials() {
  return <section className="py-24 bg-brand-dark" data-id="element-123">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-124">
        <div className="text-center mb-16" data-id="element-125">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-126">
            Lo que dicen quienes ya entrenan
          </h2>
          <p className="text-lg text-white/70 max-w-2xl mx-auto" data-id="element-127">
            Resultados reales de argentinos que decidieron optimizar su tiempo.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-128">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.08
        }} className="bg-white/5 backdrop-blur-sm rounded-2xl p-7 border border-white/10" data-id="element-129">
              <div className="flex gap-1 mb-4 text-brand-green" data-id="element-130">
                {[...Array(5)].map((_, j) => <Star key={j} size={18} fill="currentColor" data-id="element-131" />)}
              </div>
              <p className="font-serif italic text-lg text-white mb-6 leading-relaxed" data-id="element-132">
                "{t.quote}"
              </p>
              <div data-id="element-133">
                <p className="font-bold text-white" data-id="element-134">{t.name}</p>
                <p className="text-sm text-white/60" data-id="element-135">{t.role}, Argentina</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}